import React from 'react';
import { SectorPageTemplate } from '../components/SectorPageTemplate';
export function SectorBouwInstallatiePage() {
  return <SectorPageTemplate sectorName="Bouw & Installatie" sectorSlug="bouw-installatie" heroTitle="Webdesign voor bouwbedrijven en installateurs" heroDescription="Professionele websites voor aannemers, loodgieters, elektriciens en dakdekkers. Wij bouwen websites die vertrouwen uitstralen en nieuwe opdrachten opleveren." whyTitle="Waarom een goede website essentieel is in de bouw" whyDescription="Klanten zoeken online naar betrouwbare vakmensen. Een sterke website is je beste visitekaartje." whyItems={[{
    icon: 'ShieldCheckIcon',
    title: 'Vakmanschap tonen',
    description: 'Laat zien dat je een betrouwbare partij bent met keurmerken en afgeronde projecten.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokaal gevonden worden',
    description: 'Mensen zoeken een vakman in de buurt. Wij zorgen dat jij bovenaan staat in Google.'
  }, {
    icon: 'TrendingUpIcon',
    title: 'Meer opdrachten',
    description: 'Een duidelijke website met makkelijke contactopties levert direct meer offerteaanvragen op.'
  }, {
    icon: 'CameraIcon',
    title: 'Projecten presenteren',
    description: 'Een visueel portfolio overtuigt potentiële klanten sneller van jouw kwaliteiten.'
  }]} features={[{
    icon: 'FileTextIcon',
    title: 'Offerteformulier',
    description: 'Een slim formulier waarmee klanten direct de juiste informatie aanleveren voor een prijsopgave.'
  }, {
    icon: 'PhoneIcon',
    title: 'Click-to-call / WhatsApp',
    description: 'Maak het voor klanten op hun mobiel super makkelijk om direct contact op te nemen.'
  }, {
    icon: 'CameraIcon',
    title: 'Projectportfolio',
    description: "Een overzichtelijke module om voor-en-na foto's van je beste werk te tonen."
  }]} clusters={[{
    name: 'Bouwbedrijf',
    slug: 'bouwbedrijf',
    label: 'Aannemer',
    description: 'Websites voor aannemers en bouwbedrijven met focus op grote projecten.'
  }, {
    name: 'Loodgieter',
    slug: 'loodgieter',
    label: 'Loodgieter',
    description: 'Websites voor loodgieters met spoed-functie en click-to-call.'
  }, {
    name: 'Elektricien',
    slug: 'elektricien',
    label: 'Elektricien',
    description: 'Websites voor elektriciens en installatiebedrijven.'
  }, {
    name: 'Dakdekker',
    slug: 'dakdekker',
    label: 'Dakdekker',
    description: 'Websites voor dakdekkers met focus op inspecties en reparaties.'
  }]} faqs={[{
    q: 'Wat kost een website voor een bouwbedrijf?',
    a: 'De kosten variëren afhankelijk van je wensen. Een professionele website voor een bouwbedrijf begint vaak rond de €1.500. We bieden altijd een transparante prijsopgave vooraf.'
  }, {
    q: 'Hoe lang duurt het om de website te maken?',
    a: "Gemiddeld staat een website voor een bouw- of installatiebedrijf binnen 2 tot 4 weken live, afhankelijk van hoe snel we de teksten en foto's hebben."
  }, {
    q: "Kan ik zelf foto's van nieuwe projecten toevoegen?",
    a: "Ja, wij bouwen de website in WordPress. Je krijgt van ons een korte uitleg waarna je heel eenvoudig zelf nieuwe projecten en foto's kunt toevoegen."
  }, {
    q: 'Word ik ook lokaal gevonden in Google?',
    a: 'Absoluut. Lokale SEO is een standaard onderdeel van onze aanpak. We optimaliseren de website zodat je gevonden wordt door klanten in jouw werkgebied.'
  }]} relatedPages={[{
    name: 'Website laten maken',
    href: '#/website-laten-maken'
  }, {
    name: 'SEO voor websites',
    href: '#/seo-voor-websites'
  }]} data-id="element-1879" />;
}